module.exports = __webpack_public_path__ + "static/img/donation_empty.a0f3646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/donation_empty.png
// module id = 1rir
// module chunks = 1